// Disclosure for the header menus (templates/layout/language-menu.ejs, menu-guides.ejs; [data-ps-disclosure]):
// the button toggles a list of plain links, so Tab still walks them in document order;
// arrows move between them, Escape and a click or focus outside close the list.
export function initDisclosureMenu(root: HTMLElement): void {
    const toggle = root.querySelector<HTMLButtonElement>('button[aria-controls]')!;
    const list = root.querySelector<HTMLElement>(`#${toggle.getAttribute('aria-controls')}`)!;
    const links = Array.from(list.querySelectorAll<HTMLAnchorElement>('a'));
    const isOpen = () => !list.hidden;

    const setOpen = (open: boolean) => {
        list.hidden = !open;
        toggle.setAttribute('aria-expanded', String(open));
    };
    const focusLink = (index: number) => links[(index + links.length) % links.length].focus();

    toggle.addEventListener('click', () => setOpen(!isOpen()));

    root.addEventListener('keydown', (event) => {
        const index = links.indexOf(document.activeElement as HTMLAnchorElement);
        if (event.key === 'Escape' && isOpen()) {
            event.preventDefault();
            setOpen(false);
            toggle.focus();
        } else if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
            event.preventDefault();
            const step = event.key === 'ArrowDown' ? 1 : -1;
            if (index >= 0) {
                focusLink(index + step);
            } else {
                setOpen(true);
                const currentIndex = links.findIndex((link) => link.hasAttribute('aria-current'));
                focusLink(currentIndex >= 0 ? currentIndex : 0);
            }
        } else if ((event.key === 'Home' || event.key === 'End') && index >= 0) {
            event.preventDefault();
            focusLink(event.key === 'Home' ? 0 : -1);
        }
    });

    root.addEventListener('focusout', (event) => {
        if (!root.contains(event.relatedTarget as Node | null)) setOpen(false);
    });
    document.addEventListener('click', (event) => {
        if (isOpen() && !root.contains(event.target as Node)) setOpen(false);
    });
}
